// @flow
import React, { Component } from 'react';
import BrandingBrandCards from 'containers/list/BrandingBrandCards';
import BrandingTemplate from 'components/branding/BrandingTemplate/BrandingTemplate';
import { Helmet } from 'react-helmet';
import type { ContextRouter } from 'react-router-dom';
import ScrollToTop from 'components/common/ScrollToTop';
import queryString from 'query-string';

type Props = {} & ContextRouter;

class Branding extends Component<Props> {
  generateStructuredData = () => {
    const currentUrl = `${process.env.BASE_URL}${this.props.location.pathname}${this.props.location.search}`;

    return {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '브랜드 목록 - 캐시바이',
      description:
        '캐시바이에서 판매하는 다양한 브랜드들을 만나보세요. 실험용품, 연구장비, 화학시약 등 전문 브랜드를 한 곳에서 확인할 수 있습니다.',
      url: currentUrl,
      mainEntity: {
        '@type': 'ItemList',
        name: '판매 브랜드 목록',
        description: '캐시바이 플랫폼에서 제공하는 브랜드 컬렉션',
        numberOfItems: '100+',
        itemListElement: [],
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '홈',
            item: process.env.BASE_URL,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '브랜드',
            item: currentUrl,
          },
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: '캐시바이',
        url: process.env.BASE_URL,
        logo: {
          '@type': 'ImageObject',
          url: `${process.env.BASE_URL}/logo.png`,
        },
      },
    };
  };

  generateMetaTags = () => {
    const { category } = this.props.match.params;
    const { sort } = queryString.parse(this.props.location.search);

    let title = '브랜드 목록 | 캐시바이';
    let description =
      '캐시바이에서 판매하는 다양한 브랜드들을 만나보세요. 실험용품, 연구장비, 화학시약 등 전문 브랜드를 한 곳에서 확인할 수 있습니다.';

    if (category) {
      title = `${category} 브랜드 | 캐시바이`;
      description = `${category} 카테고리의 브랜드들을 확인하세요. 캐시바이에서 엄선한 ${category} 전문 브랜드 제품들을 만나보실 수 있습니다.`;
    }

    if (sort) {
      const sortText = sort === 'popular' ? '인기순' : sort === 'newest' ? '최신순' : '';
      if (sortText) {
        title = `브랜드 목록 (${sortText}) | 캐시바이`;
      }
    }

    return { title, description };
  };

  render() {
    const { location, match, history } = this.props;
    const { sort } = queryString.parse(location.search);
    const { category } = match.params;
    const { title, description } = this.generateMetaTags();
    const structuredData = this.generateStructuredData();
    const currentUrl = `${process.env.BASE_URL}${location.pathname}${location.search}`;

    return (
      <BrandingTemplate>
        <Helmet>
          {/* 기본 메타 태그 */}
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta
            name="keywords"
            content="브랜드, 실험용품, 연구장비, 화학시약, 캐시바이, 과학장비, 실험기기, 연구용품"
          />
          <link rel="canonical" href={currentUrl} />

          {/* Open Graph 메타 태그 */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:url" content={currentUrl} />
          <meta property="og:site_name" content="캐시바이" />
          <meta property="og:image" content="https://images.cacheby.com/cacheby.png" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:locale" content="ko_KR" />

          {/* Twitter Card 메타 태그 */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={title} />
          <meta name="twitter:description" content={description} />
          <meta name="twitter:image" content="https://images.cacheby.com/cacheby.png" />
          <meta name="twitter:site" content="@cacheby" />

          {/* 추가 SEO 메타 태그 */}
          <meta
            name="robots"
            content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
          />
          <meta name="googlebot" content="index, follow" />
          <meta name="author" content="캐시바이" />
          <meta name="publisher" content="캐시바이" />
          <meta httpEquiv="content-language" content="ko-KR" />

          {/* 구조화된 데이터 */}
          <script type="application/ld+json">{JSON.stringify(structuredData)}</script>

          {/* 추가 링크 태그 */}
          <link rel="alternate" hrefLang="ko" href={currentUrl} />
          <link rel="preconnect" href="https://images.cacheby.com" />
          <link rel="dns-prefetch" href="https://images.cacheby.com" />
        </Helmet>
        <BrandingBrandCards category={category} sort={sort} />
      </BrandingTemplate>
    );
  }
}

export default Branding;



// WEBPACK FOOTER //
// ./src/pages/Branding.js